'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.service:SurveyService
 * @description
 * #SurveyService
 * Service of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').service('ReportService', ['$q', '$http', 'ApiUrl', '$window',
    function ($q, $http, ApiUrl, $window) {

        var _apiUrl = ApiUrl.url('/Reporting/');
        var _emptyPromptId = 55; //Id for promptless (non-matrix style) groupings


        var _parseSurveyResponse = function (inputObj) {
            var outputArr = {
                sections: [],
                compositeScores: []
            };
            var questionCount = 1;

            for (var i = 0; i < inputObj.Sections.length; i++) {

                var tempSection = {
                    SectionText: inputObj.Sections[i].SectionText,
                    SectionID: inputObj.Sections[i].SectionID,
                    QuestionPrompts: []
                };

                for (var j = 0; j < inputObj.Sections[i].QuestionPrompts.length; j++) {

                    //need to treat questions grouped under the 'no-prompt' PromptID separately
                    if (inputObj.Sections[i].QuestionPrompts[j].QuestionPromptID === _emptyPromptId) {
                        //add each question to the array 
                        for (var k = 0; k < inputObj.Sections[i].QuestionPrompts[j].Questions.length; k++) {
                            tempSection.QuestionPrompts.push(inputObj.Sections[i].QuestionPrompts[j].Questions[k]);
                        } // end k-loop 1
                    }
                        //otherwise its a matrix 
                    else {
                        var promptCount = 1;
                        var tempPrompt = {
                            QuestionPromptID: inputObj.Sections[i].QuestionPrompts[j].QuestionPromptID,
                            QuestionPromptText: inputObj.Sections[i].QuestionPrompts[j].QuestionPromptText,
                            Questions: []
                        };
                        for (var p = 0; p < inputObj.Sections[i].QuestionPrompts[j].Questions.length; p++) {
                            tempPrompt.Questions.push(inputObj.Sections[i].QuestionPrompts[j].Questions[p]);
                            tempPrompt.Questions[p].promptCount = promptCount;
                            promptCount++;
                        } //end k-loop 2

                        //add last row of matrix/table sortby value to the prompt object for sorting
                        tempPrompt.SortOrder = tempPrompt.Questions[tempPrompt.Questions.length - 1].SortOrder;
                        tempSection.QuestionPrompts.push(tempPrompt);
                    } //end parse matrix

                } // end j - question prompts loop

                //sort question prompts in the section
                tempSection.QuestionPrompts.sort(function (a, b) {
                    return a.SortOrder - b.SortOrder;
                });
                for (var z = 0; z < tempSection.QuestionPrompts.length; z++) {
                    tempSection.QuestionPrompts[z].questionCount = questionCount;
                    questionCount++;
                }
                outputArr.sections.push(tempSection);
            } // end i - sections loop

            if (inputObj.CompositeScores !== null) {
                for (var i = 0; i < inputObj.CompositeScores.length; i++) {

                    var tempCompositeScore = {
                        Name: inputObj.CompositeScores[i].Name,
                        CompositeScoreID: inputObj.CompositeScores[i].CompositeScoreID,
                        Mean: 0,
                        StandardDev: 0,
                        TotalCount: 0,
                        QuestionPrompts: []
                    };

                    for (var j = 0; j < inputObj.CompositeScores[i].QuestionPrompts.length; j++) {

                        //need to treat questions grouped under the 'no-prompt' PromptID separately
                        if (inputObj.CompositeScores[i].QuestionPrompts[j].QuestionPromptID === _emptyPromptId) {
                            //add each question to the array 
                            for (var k = 0; k < inputObj.CompositeScores[i].QuestionPrompts[j].Questions.length; k++) {
                                tempCompositeScore.QuestionPrompts.push(inputObj.CompositeScores[i].QuestionPrompts[j].Questions[k]);
                            } // end k-loop 1
                        }
                        //otherwise its a matrix 
                        else {
                            var promptCount = 1;
                            var tempPrompt = {
                                QuestionPromptID: inputObj.CompositeScores[i].QuestionPrompts[j].QuestionPromptID,
                                QuestionPromptText: inputObj.CompositeScores[i].QuestionPrompts[j].QuestionPromptText,
                                Questions: []
                            };
                            for (var p = 0; p < inputObj.CompositeScores[i].QuestionPrompts[j].Questions.length; p++) {
                                tempPrompt.Questions.push(inputObj.CompositeScores[i].QuestionPrompts[j].Questions[p]);
                                tempPrompt.Questions[p].promptCount = promptCount;
                                promptCount++;
                            } //end k-loop 2

                            //add last row of matrix/table sortby value to the prompt object for sorting
                            tempPrompt.SortOrder = tempPrompt.Questions[tempPrompt.Questions.length - 1].SortOrder;
                            tempCompositeScore.QuestionPrompts.push(tempPrompt);
                        } //end parse matrix

                    } // end j - question prompts loop
                    outputArr.compositeScores.push(tempCompositeScore);
                } // end i - composite scores loop
            }
            return outputArr;
        };

        //Reporting Service Public API 
        return {

            getSurveyReport: function (surveyID, filter, isBase) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'Survey/' + surveyID + '/' + filter + '/' + isBase).then(function (response) {
                    deferred.resolve(_parseSurveyResponse(response.data));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            getSurveySummary: function (surveyID, isBase, filter) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'Summary/' + surveyID + '/' + isBase + '/' + filter).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },
            downloadDataCsv: function (surveyID, filters) {
                var url = _apiUrl + 'DownloadData?surveyID=' + encodeURIComponent(surveyID);
                if (filters !== undefined) {
                    url += '&filter=' + encodeURIComponent(filters.filter) +
                    '&custom=' + encodeURIComponent(filters.custom) +
                    '&curated=' + encodeURIComponent(filters.curated) +
                    '&profile=' + encodeURIComponent(filters.profile);
                }

                $window.location = url;
            },
            downloadAggregateDataCsv: function (baseSurveyID, filters) {
                var url = _apiUrl + 'DownloadAggregateData?baseSurveyId=' + encodeURIComponent(baseSurveyID) + '&filter=' + encodeURIComponent(filters.filter) + '&curated=' + encodeURIComponent(filters.curated) + '&profile=' + encodeURIComponent(filters.profile);
                $window.location = url;
            },
            downloadGrantDetailsCsv: function (startDate, endDate) {
                var url = _apiUrl + 'DownloadGrantDetailsCsv?startDate=' + encodeURIComponent(startDate) + '&endDate=' + encodeURIComponent(endDate);
                $window.location = url;
            },
            setReportQuestionDetails: function (question, reportId, summary) {
                //use session storage if available, if not, fall back to storage on this object (will disappear on refresh)
                if ($window.Storage) {
                    $window.sessionStorage.setItem('reportQuestion', angular.toJson(question));
                    $window.sessionStorage.setItem('reportID', reportId);
                    $window.sessionStorage.setItem('reportSummary', angular.toJson(summary));
                }
                else {
                    this.questionDetails = question;
                    this.reportId = reportId;
                    this.summary = summary;
                }
            },
            getReportQuestionDetails: function () {

                if ($window.Storage) {
                    var question = angular.fromJson($window.sessionStorage.getItem('reportQuestion'));
                    var reportId = $window.sessionStorage.getItem('reportID');
                    var summary = angular.fromJson($window.sessionStorage.getItem('reportSummary'));
                    return {
                        question: question,
                        reportId: reportId,
                        summary: summary
                    };
                }
                else {
                    return {
                        question: this.questionDetails,
                        reportId: this.reportId,
                        summary: this.summary
                    };
                }
            },
            clearReportQuestionDetails: function () {
                if ($window.Storage) {
                    $window.sessionStorage.removeItem('reportQuestion');
                    $window.sessionStorage.removeItem('reportID');
                    $window.sessionStorage.removeItem('reportSummary');
                }
                else {
                    this.questionDetails = {};
                    this.reportId = null;
                    this.summary = {};
                }
            },
            
            saveDataSharingAgreement: function (response) {
                return $http.post(_apiUrl + 'SaveDataSharingAgreement', response);
            },


            /*-----------------------------------------------
             * 'Public' Variables constructor
             */
            questionDetails: {},
            reportId: null,
            summary: {},
            aggregateReportQuestion: {},
            aggregateReportID: null,
            aggregateReportIncludeNSF: null

        };
    }]);